var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.275C1 0.123122 1.11193 0 1.25 0H9.75C9.88807 0 10 0.123122 10 0.275V1.1C10 1.25188 9.88807 1.375 9.75 1.375H1.25C1.11193 1.375 1 1.25188 1 1.1V0.275Z",
    fill: "#F5D35C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.2C0 2.04812 0.111929 1.925 0.25 1.925H9C9.13807 1.925 9.25 2.04812 9.25 2.2V3.025C9.25 3.17688 9.13807 3.3 9 3.3H0.25C0.111929 3.3 0 3.17688 0 3.025V2.2Z",
    fill: "#F5D35C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 6.05C0.25 5.89812 0.361929 5.775 0.5 5.775H10.75C10.8881 5.775 11 5.89812 11 6.05V6.875C11 7.02688 10.8881 7.15 10.75 7.15H0.5C0.361929 7.15 0.25 7.02688 0.25 6.875V6.05Z",
    fill: "#F5D35C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.9C0 9.74812 0.111929 9.625 0.25 9.625H10C10.1381 9.625 10.25 9.74812 10.25 9.9V10.725C10.25 10.8769 10.1381 11 10 11H0.25C0.111929 11 0 10.8769 0 10.725V9.9Z",
    fill: "#F5D35C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.125C1.5 3.97312 1.61193 3.85 1.75 3.85H9.75C9.88807 3.85 10 3.97312 10 4.125V4.95C10 5.10188 9.88807 5.225 9.75 5.225H1.75C1.61193 5.225 1.5 5.10188 1.5 4.95V4.125Z",
    fill: "#F5D35C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.975C1 7.82312 1.11193 7.7 1.25 7.7H9.25C9.38807 7.7 9.5 7.82312 9.5 7.975V8.8C9.5 8.95188 9.38807 9.075 9.25 9.075H1.25C1.11193 9.075 1 8.95188 1 8.8V7.975Z",
    fill: "#F5D35C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.8fd76cde631c9182760393509ac6c740.svg";
export { ForwardRef as ReactComponent };